<template>
  <div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal text-black">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                :name="tab === 'inicio' ? 'close' : 'arrow_back_ios'"
                class="q-mr-md"
                size="22px"
                @click="
                  tab === 'inicio' ? $emit('fecharModal') : (tab = 'inicio')
                "
              />
              <span style="font-size: 16px">
                <span>
                  <span class="texto-titulo-modal">
                    {{
                      tab === "inicio"
                        ? tipoModal == "editarAtivo"
                          ? "Editar Ativo"
                          : "Criar Ativo"
                        : tab === "atributos"
                        ? "Adicionar Atributos"
                        : tab === "checklist"
                        ? "Adicionar Checklist"
                        : tab === "acessorios"
                        ? "Adicionar Acessórios"
                        : ""
                    }}
                  </span>
                </span>
              </span>
            </div>
            <div class="justify-end row col-md-12 col-lg-12 col-xs-12 q-mt-xs">
              <div class="row col-12 col-xs-12 container-tab justify-end">
                <q-tabs v-model="tab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="atributos"
                    label="Atributos"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="checklist"
                    label="Checklist"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="acessorios"
                    label="Acessórios"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
        </div>
        <q-scroll-area
          v-if="tab === 'checklist'"
          style="width: 100%; height: 80%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 100%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs items-center q-mb-lg">
                <div class="col">
                  <div class="texto-titulo-input q-mb-xs">Checklist</div>
                  <SelecaoChecklist
                    @enviarChecklist="receberChecklist"
                    :catalogoUuidEspecifico="catalogoEspecificoUuid"
                    :multiple="false"
                    :resetar="resetarChecklist"
                  />
                </div>
                <div>
                  <p></p>
                  <q-btn
                    icon="add"
                    flat
                    class="q-mt-xs q-ml-sm"
                    round
                    color="primary"
                    @click="
                      tipoModal == 'editarAtivo'
                        ? associarChecklist(checklist?.checkListUuid)
                        : adicionarLinhaChecklist(checklist)
                    "
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Checklist Adicionados
                </div>
                <div
                  v-for="(checklist, index) in editarItemCatalogo?.checkLists"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <span
                      class="row col-12 texto-conteudo-tabela"
                      style="word-break: break-all"
                      >{{ index + 1 }}- {{ checklist.nome }}</span
                    >
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm icon-tabela"
                      @click="
                        tipoModal == 'editarAtivo'
                          ? desassociarChecklist(checklist.checkListUuid)
                          : removerIndiceChecklist(index)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'inicio' && tipoModal == 'editarAtivo'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Código</div>
                <q-input
                  disable
                  bg-color="brand-7"
                  v-model="editarItemCatalogo.codigo"
                  dense
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Descrição</div>
                <q-input
                  v-model="editarItemCatalogo.descricao"
                  dense
                  disable
                  bg-color="brand-7"
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Origem*</div>
                <q-select
                  :options="options.origem"
                  v-model="editarItemCatalogo.origem"
                  behavior="menu"
                  dense
                  disable
                  map-options
                  bg-color="brand-7"
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Patrimônio<span
                    v-if="
                      editarItemCatalogo?.origem != 'consumo' &&
                      editarItemCatalogo?.origem?.value != 'consumo'
                    "
                    >*</span
                  >
                </div>
                <q-input
                  v-model="editarItemCatalogo.patrimonio"
                  dense
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Tempo de Permanencia
                </div>
                <q-input
                  v-model="editarItemCatalogo.tempoPermanencia"
                  dense
                  outlined
                  type="number"
                  min="1"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Preço</div>
                <QCurrencyInput v-model="editarItemCatalogo.valor" />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Valor Locação</div>
                <QCurrencyInput v-model="editarItemCatalogo.valorLocacao" />
              </div>
            </div>
            <div class="row col-12 q-px-md q-mt-md q-pb-lg btn-editar">
              <div>
                <q-btn
                  class="q-mt-sm"
                  icon="done"
                  label="Salvar"
                  no-caps
                  color="positive"
                  @click="verificarCampo()"
                />
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'inicio' && tipoModal == undefined"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Código</div>
                <q-input
                  disable
                  bg-color="brand-7"
                  v-model="editarItemCatalogo.codigo"
                  dense
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Descrição</div>
                <q-input
                  v-model="editarItemCatalogo.descricao"
                  dense
                  disable
                  bg-color="brand-7"
                  outlined
                />
              </div>
              <div v-if="operacao" class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Operação*</div>
                <SelecaoOperacao
                  :model="editarItemCatalogo.operacao"
                  @enviarOperacao="receberOperacao"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <SelecaoLocalDeposito
                  :unidadeId="unidadeIdEspecifico"
                  :autoSelecionar="true"
                  :model="editarItemCatalogo?.deposito"
                  @enviarDeposito="receberDeposito"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Origem*</div>
                <q-select
                  :options="
                    ($store.state.autenticacao.cliente.includes('acciona') ||
                      $store.state.autenticacao.cliente.includes(
                        'staging-acciona'
                      )) &&
                    esconderLocada == true
                      ? options.origemAlternativa
                      : options.origem
                  "
                  v-model="editarItemCatalogo.origem"
                  behavior="menu"
                  dense
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Patrimônio<span
                    v-if="editarItemCatalogo?.origem?.value != 'consumo'"
                    >*</span
                  >
                </div>
                <q-input
                  v-model="editarItemCatalogo.patrimonio"
                  dense
                  outlined
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Tempo de Permanencia
                </div>
                <q-input
                  v-model="editarItemCatalogo.tempoPermanencia"
                  dense
                  outlined
                  type="number"
                  min="1"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Preço</div>
                <QCurrencyInput v-model="editarItemCatalogo.valor" />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Valor Locação</div>
                <QCurrencyInput v-model="editarItemCatalogo.valorLocacao" />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Responsável</div>
                <SelecaoFuncionario
                  @emitirFuncionario="receberFuncionario"
                  :model="editarItemCatalogo.responsavel"
                />
              </div>
              <div v-if="fornecedor" class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Fornecedor</div>
                <SelecaoFornecedor
                  :model="editarItemCatalogo.fornecedor"
                  :unidadeId="$store.state.org.unidadeData.id"
                  :desabilitado="true"
                  @enviarFornecedor="receberFornecedor"
                />
              </div>
              <div v-if="multiplicar" class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Multiplo</div>
                <q-input
                  v-model="editarItemCatalogo.multiplo"
                  dense
                  outlined
                  type="number"
                />
              </div>
            </div>
            <div class="row col-12 q-px-md q-mt-md q-pb-lg btn-editar">
              <div>
                <q-btn
                  v-if="criarAtivo != undefined"
                  class="q-mt-sm"
                  icon="done"
                  label="Criar"
                  no-caps
                  color="positive"
                  @click="validarMultiplo()"
                />
                <q-btn
                  v-else
                  class="q-mt-sm"
                  icon="done"
                  label="Salvar"
                  no-caps
                  color="positive"
                  @click="verificarCampo()"
                />
              </div>
              <q-btn
                v-if="multiplicar"
                class="q-mt-sm q-ml-sm"
                icon="edit"
                label="Editar"
                no-caps
                color="primary"
                @click="multiplicarCampo()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'atributos'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg items-center">
                <div class="col-md-3 col-xs">
                  <div class="texto-titulo-input q-mb-xs">Chave</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo.chave"
                    dense
                    outlined
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                  />
                </div>
                <div class="col-md col-xs-4 q-ml-xs">
                  <div class="texto-titulo-input q-mb-xs">Valor</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo.valor"
                    dense
                    outlined
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                  />
                </div>
                <div>
                  <p></p>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    class="q-ml-sm q-mt-xs"
                    @click="
                      tipoModal == 'editarAtivo'
                        ? adicionarAtributo()
                        : adicionarLinhaAtributo(index)
                    "
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Atributos Criados
                </div>
                <div
                  v-for="(atributo, index) in editarItemCatalogo?.atributos"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                      style="word-break: break-all"
                    >
                      <span class="col"
                        >{{ index + 1 }}- <strong>Chave:</strong>
                        {{ atributo.chave }}</span
                      >
                      <span class="col"
                        ><strong class="q-mr-xs">Valor:</strong>
                        {{ atributo.valor }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      @click="
                        tipoModal == 'editarAtivo'
                          ? excluirAtributo(atributo.chave)
                          : removerIndiceAtributo(index)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'acessorios'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg items-center">
                <div class="col-md col-xs">
                  <div class="texto-titulo-input q-mb-xs">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAcessorio"
                    dense
                    outlined
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                  />
                </div>
                <div>
                  <p></p>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    class="q-ml-sm q-mt-xs icon"
                    @click="
                      tipoModal == undefined
                        ? adicionarLinhaAcessorio()
                        : adicionarAcessorio()
                    "
                  />
                </div>
              </div>
              <div class="q-mb-md">
                <div class="texto-titulo-tabela">
                  Lista de Acessórios Criados
                </div>
                <div
                  v-for="(acessorio, index) in editarItemCatalogo?.acessorios"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                    >
                      <span class="col" style="word-break: break-all"
                        >{{ index + 1 }}- <strong>Nome:</strong>
                        {{ acessorio.nome }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      @click="
                        tipoModal == 'editarAtivo'
                          ? excluirAcessorio(acessorio.uuid)
                          : removerIndiceAcessorio(index)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import QCurrencyInput from "./InputFormatarPreco.vue";
import SelecaoChecklist from "./SelecaoChecklist.vue";
import SelecaoFuncionario from "./SelecaoFuncionario.vue";
import SelecaoLocalDeposito from "./SelecaoLocalDeposito.vue";
import SelecaoFornecedor from "./SelecaoFornecedor.vue";
import SelecaoOperacao from "./SelecaoOperacao.vue";

export default {
  components: {
    SelecaoChecklist,
    SelecaoFuncionario,
    SelecaoLocalDeposito,
    SelecaoFornecedor,
    SelecaoOperacao,
    QCurrencyInput,
  },
  props: [
    "rightDrawerOpen",
    "operacao",
    "itemCatalogo",
    "multiplicar",
    "criarAtivo",
    "resetarMultiplo",
    "fornecedor",
    "unidadeId",
    "fornecedorAlocado",
    "tipoModal",
    "catalogoEspecificoUuid",
    "unidadeIdEspecifico",
    "esconderLocada",
    "validacaoCriacao",
  ],
  emits: ["fecharModal", "salvarAlteracoes", "multiplicarCampo", "criarAtivo"],
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();

    const catalogoUuid = salvarCatalogoUuid();
    const dadoAcessorio = ref("");
    const editarItemCatalogo = ref(props.itemCatalogo);
    const checklist = ref({});
    let criarAtivoCatalogo = ref(false);
    const tab = ref("inicio");
    const resetarChecklist = ref(0);
    const imageUrl = ref("");
    const img = ref(null);
    const multiplo = ref(1);
    const disableAtributo = ref(false);
    const disableChecklist = ref(false);
    const modelValue = ref("");
    const disableAcessorio = ref(false);
    const options = ref({
      origemAlternativa: [
        {
          label: "Própria",
          value: "propria",
        },

        {
          label: "Consumo",
          value: "consumo",
        },
      ],
      origem: [
        {
          label: "Própria",
          value: "propria",
        },
        {
          label: "Locada",
          value: "locada",
        },
        {
          label: "Consumo",
          value: "consumo",
        },
      ],
    });
    const dadoAtributo = ref({ chave: "", valor: "" });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const receberChecklist = (value) => {
      checklist.value = value;
    };

    const removerIndiceAcessorio = (index) => {
      editarItemCatalogo.value.acessorios.splice(index, 1);
    };

    const removerIndiceChecklist = (index) => {
      if (editarItemCatalogo.value.checkLists.length == 1) {
        quasar.notify({
          message: "É obrigatório ter a o menos um checklist.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      editarItemCatalogo.value.checkLists.splice(index, 1);
    };

    const resetAtributoCriar = () => {
      dadoAtributo.value = {
        chave: "",
        valor: "",
      };
    };

    const adicionarLinhaAtributo = async () => {
      let valido = editarItemCatalogo.value?.atributos.every(
        (value) => value.chave != dadoAtributo.value.chave
      );
      if (dadoAtributo.value.chave == "" || dadoAtributo.value.valor == "") {
        quasar.notify({
          message: "O campo chave e valor não podem ser vazios.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (!valido) {
        quasar.notify({
          message:
            "Já existe um atributo com os mesmos valores adicionado ao item.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      editarItemCatalogo.value?.atributos.push({
        chave: dadoAtributo.value.chave,
        valor: dadoAtributo.value.valor,
      });
      resetAtributoCriar();
    };

    const removerIndiceAtributo = (index) => {
      editarItemCatalogo.value?.atributos.splice(index, 1);
    };

    const adicionarAcessorio = async () => {
      if (validacaoCaracteresEspeciais(dadoAcessorio.value) != true) {
        return;
      }
      disableAcessorio.value = true;
      try {
        await store.dispatch("ferramentaria/adicionarAcessorioAtivo", {
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          acessorios: [{ nome: dadoAcessorio.value }],
        });
        listarAcessorio();
        dadoAcessorio.value = "";
        quasar.notify({
          message: "Acessório adicionado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAcessorio.value = false;
      } catch (error) {
        if (error.response.data.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const adicionarLinhaAcessorio = () => {
      if (dadoAcessorio.value == "") {
        quasar.notify({
          message: "O campo nome não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      editarItemCatalogo.value.acessorios.push({ nome: dadoAcessorio.value });
      dadoAcessorio.value = "";
    };

    const adicionarLinhaChecklist = (checklist) => {
      if (editarItemCatalogo.value.checkLists.length > 0) {
        let valido = editarItemCatalogo.value.checkLists.every(
          (value) => value.checkListUuid != checklist.checkListUuid
        );
        if (!valido) {
          quasar.notify({
            message: "Checklist já adicionado.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      if (
        checklist.checkListUuid == "" ||
        checklist.checkListUuid == undefined
      ) {
        quasar.notify({
          message: "Selecione um checklist.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      editarItemCatalogo.value.checkLists.push({
        checkListUuid: checklist.checkListUuid,
        nome: checklist.nome,
        descricao: checklist.descricao,
      });
      resetarChecklist.value++;
    };

    const receberFuncionario = (value) => {
      if (value === null || value === undefined) {
        editarItemCatalogo.value.responsavel = "";
        return;
      }
      editarItemCatalogo.value.responsavel = value;
    };

    const receberDeposito = (value) => {
      editarItemCatalogo.value.deposito = value;
    };

    const verificarCampo = () => {
      if (
        (store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")) &&
        props.validacaoCriacao &&
        editarItemCatalogo.value?.origem?.value == "locada" &&
        !editarItemCatalogo.value.valorLocacao
      ) {
        quasar.notify({
          message: "Por favor, informe o valor de locação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      emit("fecharModal");
    };

    const multiplicarCampo = async () => {
      if (editarItemCatalogo.value.multiplo == undefined) {
        quasar.notify({
          message:
            "O valor do multiplo não pode ser menor que 2 ou maior que 50.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        editarItemCatalogo.value.multiplo < 2 ||
        editarItemCatalogo.value.multiplo > 50
      ) {
        quasar.notify({
          message:
            "O valor do multiplo não pode ser menor que 2 ou maior que 50.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      emit("multiplicarCampo", {
        multiplo: parseInt(editarItemCatalogo.value.multiplo),
        itemSelecionado: editarItemCatalogo.value,
      });
    };

    const excluirAtributo = async (chaveAtributo) => {
      try {
        await store.dispatch("ferramentaria/excluirAtributoAtivo", {
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          chaveAtributo,
        });
        listarAtributo();
        quasar.notify({
          message: "Atributo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir atributo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirAcessorio = async (acessorioUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirAcessorioAtivo", {
          acessorioUuid,
          ativoUuid: editarItemCatalogo.value.ativoUuid,
        });
        listarAcessorio();
        quasar.notify({
          message: "Acessório excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir acessório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarAtributo = async () => {
      if (
        validacaoCaracteresEspeciais(dadoAtributo.value.chave) != true ||
        validacaoCaracteresEspeciais(dadoAtributo.value.valor) != true
      ) {
        return;
      }
      disableAtributo.value = true;
      try {
        await store.dispatch("ferramentaria/adicionarAtributoAtivo", {
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          atributos: [dadoAtributo.value],
        });
        listarAtributo();
        resetAtributoCriar();
        quasar.notify({
          message: "Atributo criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      }
    };

    const associarChecklist = async (checkListUuid) => {
      if (checkListUuid === "" || checkListUuid === undefined) {
        quasar.notify({
          message: "Selecione um checklist para associar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/associarCheckListAtivo", {
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          checklListUuid: checkListUuid,
        });
        quasar.notify({
          message: "Checklist associado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarChecklist();
        resetarChecklist.value++;
      } catch (error) {
        disableChecklist.value = false;
        if (error.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          error.response?.data?.erro?.mensagem ==
          `O checklist [${checkListUuid}] já está associado a este item [${editarItemCatalogo.value.uuid}].`
        ) {
          quasar.notify({
            message: `O Checklist: ${checklist.value.nome} já esta associado a ferramenta.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        if (error.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        disableChecklist.value = false;
      }
    };

    const desassociarChecklist = async (checklListUuid) => {
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/desassociarCheckListAtivo", {
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          checklListUuid: checklListUuid,
        });
        quasar.notify({
          message: "Checklist desassociado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        checklist.value = "";
        listarChecklist();
      } catch (error) {
        disableChecklist.value = false;
        if (error.response.data.erros.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const validacaoCaracteresEspeciais = (val) => {
      const regex = /[^a-zA-Z0-9\s]/g; // Expressão regular para caracteres especiais

      if (regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true; // Validação passou
      }
    };

    const validarMultiplo = () => {
      if (props.multiplicar == true) {
        if (multiplo.value < 1 || multiplo.value > 50) {
          quasar.notify({
            message:
              "O valor do multiplo não pode ser menor que 2 ou maior que 50.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      if (
        (store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")) &&
        props.validacaoCriacao &&
        editarItemCatalogo.value?.origem?.value == "locada" &&
        !editarItemCatalogo.value.valorLocacao
      ) {
        quasar.notify({
          message: "Por favor, informe o valor de locação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      emit("criarAtivo", {
        multiplo: multiplo.value,
        itemSelecionado: editarItemCatalogo.value,
      });
    };

    const validacaoCaracteresChecklist = (val) => {
      const regex = /^[a-zA-ZÀ-ÖØ-öØ-ÿ?Çç\s]*$/;

      if (!regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true;
      }
    };

    const receberFornecedor = (value) => {
      editarItemCatalogo.value.fornecedor = value;
    };

    const receberOperacao = (value) => {
      editarItemCatalogo.value.operacao = value;
    };

    const listarAtributo = async () => {
      if (editarItemCatalogo.value.ativoUuid == undefined) {
        return;
      }
      disableAtributo.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAtributoAtivo",
          {
            ativoUuid: editarItemCatalogo.value.ativoUuid,
          }
        );
        disableAtributo.value = false;
        editarItemCatalogo.value.atributos =
          response.response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const listarChecklist = async () => {
      disableChecklist.value = true;
      if (editarItemCatalogo.value.ativoUuid == undefined) {
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist", {
          catalogoUuid:
            props.catalogoEspecificoUuid || catalogoUuid.catalogoUuid.value,
          per_page: 100,
          page: 1,
          ativoUuid: editarItemCatalogo.value.ativoUuid,
        });
        editarItemCatalogo.value.checkLists = response.data.resultado.dados;
        disableChecklist.value = false;
      } catch (error) {
        disableChecklist.value = false;
        console.log(error);
      }
    };

    const listarAcessorio = async () => {
      disableAcessorio.value = true;
      await editarItemCatalogo.value.ativoUuid;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          unidadeId: props.unidadeId,
          ativoUuid: editarItemCatalogo.value.ativoUuid,
          comAcessorios: "sim",
          comFornecedorAlocado: props.fornecedorAlocado ? "sim" : undefined,
          fornecedorAlocado: props.fornecedorAlocado
            ? props.fornecedor
            : undefined,
        });
        if (response.response.data.resultado?.dados[0]?.acessorios.length > 0) {
          editarItemCatalogo.value.acessorios =
            response.response.data.resultado.dados[0].acessorios;
        }
        disableAcessorio.value = false;
      } catch (error) {
        console.log(error);
        disableAcessorio.value = false;
      }
    };

    watch(
      () => img.value,
      () => {
        if (editarItemCatalogo.value?.url != null && img?.value?.name) {
          editarItemCatalogo.value.url = "";
        }
      }
    );

    watch(
      () => props.itemCatalogo,
      () => {
        editarItemCatalogo.value = props.itemCatalogo;
        if (props.tipoModal == "editarAtivo") {
          listarAtributo();
          listarChecklist();
          listarAcessorio();
        }
      }
    );

    watch(
      () => img.value,
      () => {
        if (img.value == null) {
          return;
        }
        if (img.value == null || !img?.value?.type.includes("image")) {
          quasar.notify({
            message: "Selecione uma imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          img.value = null;
          return;
        }
        let fileReader = new FileReader();
        fileReader.readAsDataURL(img.value);
        fileReader.addEventListener("load", () => {
          imageUrl.value = fileReader.result;
          editarItemCatalogo.value.url = fileReader.result;
        });
      }
    );

    watch(
      () => props.rightDrawerOpen,
      () => {
        if (props.rightDrawerOpen == false) {
          emit("salvarAlteracoes", editarItemCatalogo.value);
          tab.value = "inicio";
        }
        if (props.tipoModal === "editarAtivo") {
          listarAtributo();
          listarChecklist();
          listarAcessorio();
        }
      }
    );

    watch(
      () => props.resetarMultiplo,
      () => {
        multiplo.value = 1;
      }
    );

    return {
      dadoAcessorio,
      editarItemCatalogo,
      checklist,
      criarAtivoCatalogo,
      receberChecklist,
      receberOperacao,
      listarChecklist,
      removerIndiceAcessorio,
      excluirAtributo,
      removerIndiceChecklist,
      receberFornecedor,
      adicionarAtributo,
      verificarCampo,
      excluirAcessorio,
      tab,
      associarChecklist,
      desassociarChecklist,
      options,
      adicionarLinhaAcessorio,
      resetarChecklist,
      listarAcessorio,
      adicionarLinhaChecklist,
      removerIndiceAtributo,
      dadoAtributo,
      validarMultiplo,
      disableAtributo,
      disableAcessorio,
      adicionarAcessorio,
      disableChecklist,
      resetAtributoCriar,
      adicionarLinhaAtributo,
      receberFuncionario,
      receberDeposito,
      modelValue,
      validacaoCaracteresEspeciais,
      validacaoCaracteresChecklist,
      listarAtributo,
      multiplo,
      catalogoUuid,
      img,
      multiplicarCampo,
    };
  },
};
</script>

<style scoped>
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 10;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 15px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.texto-titulo-input-modal {
  font-size: 15px;
}
.container-imagem {
  height: 210px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
.imagem-ferramenta {
  width: 100%;
  height: 200px;
}
.file-container {
  width: 100%;
  background: transparent;
  z-index: 30 !important;
}
.file {
  height: 180px;
}
.texto-alterar-imagem {
  color: black !important;
  z-index: 31;
  cursor: pointer;
  transition: all 0.5s;
}
.texto-alterar-imagem:hover {
  transform: scale(1.2);
}

@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1024px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .sem-margin {
    margin-left: 0px;
    margin-top: 5px;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .sem-margin {
    margin-left: 0px;
    margin-top: 5px;
  }
  .input {
    font-size: 12px;
  }
  .btn-imprimir {
    margin-top: 0px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .texto-titulo-input-modal {
    font-size: 13px;
  }
  .input-radio {
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-modal {
    font-size: 12px;
  }
  .btn-container {
    justify-content: center;
    flex-wrap: nowrap;
  }
  .btn {
    font-size: 13px;
  }
  .btn-enviada {
    font-size: 12px;
  }
  .container-imagem {
    height: 150px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
  .file {
    height: 120px;
  }
  .texto-alterar-imagem {
    font-size: 10px;
  }
}
</style>
